// extracted by mini-css-extract-plugin
module.exports = {"notification":"_82e3db2ea0--notification--KvXek","phone":"_82e3db2ea0--phone--cWXCB","icon":"_82e3db2ea0--icon--WzEDX"};